import React from 'react';
import { Grid, Button, Typography } from "@material-ui/core";
import '../../App.css'
import './home.css'
import { ThemeProvider, withStyles, makeStyles } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';
import homeClasses from './homeStyles.js'


const useStyle = makeStyles(() => ({
  btn: {
    borderColor: "white",
    color: "white",
    backgroundColor: "transparent", 
    "&:hover": {
        backgroundColor: "white",
        color: "#B64C4C",
        borderColor: "#B64C4C",
    },
 },
}));



const AccordionDetails = withStyles((
    theme) => ({
    root: {
        padding: theme
            .spacing(2),
            borderBottom: '1px solid rgba(255, 255, 255, .125)',
            paddingLeft: 35,
        color: '#ffffff',
    },
}))(MuiAccordionDetails);
const Accordion = withStyles({
    root: {
        backgroundColor: 'transparent',
        border: 0,
        boxShadow: 'none',
        '&:not(:last-child)': {},
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);
const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'transparent',
        borderBottom: '1px solid rgba(255, 255, 255, .125)',
        minHeight: 56,
        padding: 0,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
    expandIcon: {
        order: -1,
        marginLeft: -20,
        color: '#ffffff',
    },
})(MuiAccordionSummary);

function Solutions() {
  const globalClasses = globalUseStyles();
  const classes = useStyle();
  const homeStyles = homeClasses();
  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <ThemeProvider theme={theme}>
      <Container className={"solutionsStyle"} maxWidth={false} component="section">
          <Container className={"solutionsStyleInner"} maxWidth={false} component="section">
            <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
                <Grid className={globalClasses.containerSmall} container >
                  <Grid item xs={12} md={5} >
                      <Typography  variant="subtitle1">Our Solutions</Typography>
                      <Typography  variant="h2">How we transform your ideas</Typography>
                      <Typography  variant="body1">We believe that the best products come from a firm understanding of your users' goals and motivations – and we want to get to know them as well as you do. From that foundation, we design and develop within the agile mindset of iteration and continual improvement to ensure you and your end users love the product we deliver.   </Typography>
                      <Button to='/solutions' className={'secondaryButton'} variant="outlined" color="inherit" disableElevation component={RouterLink}>Learn more about our solutions</Button>
                  </Grid>
                  <Grid item xs={false} md={1}/>
                  <Grid item xs={12} md={6} className={globalClasses.containerTopPadding}>
                      <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')} >
                      <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={
                      <ExpandMoreIcon />
                      }
                      >
                      <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Product Strategy</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                      <Accordion square expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                      <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={
                      <ExpandMoreIcon />
                      }>
                     <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Product Management</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                      <Accordion square expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                      <AccordionSummary aria-controls="panel3d-content" id="panel3d-header" expandIcon={
                      <ExpandMoreIcon />
                      }>
                      <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Analytics</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                      <Accordion square expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                      <AccordionSummary aria-controls="panel4d-content" id="panel4d-header" expandIcon={
                      <ExpandMoreIcon />
                      }>
                      <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Development</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                      <Accordion square expanded={expanded === 'panel5'} onChange={handleChange('panel5')} >
                      <AccordionSummary aria-controls="panel5d-content" id="panel5d-header" expandIcon={
                      <ExpandMoreIcon />
                      }>
                      <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Design</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                      <Accordion square expanded={expanded === 'panel6'} onChange={handleChange('panel6')} >
                      <AccordionSummary aria-controls="panel6d-content" id="panel6d-header" expandIcon={
                      <ExpandMoreIcon />
                      }>
                      <Typography className={globalClasses.hoverStyle} variant="h4" color="textSecondary">Dev Ops</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                            sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                        </Typography>
                      </AccordionDetails>
                      </Accordion>
                  </Grid>
                </Grid>
            </Container>
          </Container>
      </Container>
    </ThemeProvider>
  );
};

export default Solutions;